import styled from 'styled-components'
import { themeGet } from 'styled-system'
import SuccessIcon from 'components/SuccessIcon'
import WarningIcon from 'components/WarningIcon'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 1.4rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1.7rem;
  width: 29.75rem;
  box-sizing: border-box;
  text-align: center;
  h2 {
    flex-basis: 83%;
  }
`

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 0;
`

export const FooterText = styled.div`
  color: green;
  height: 10rem;
  width: 100%;
`

export const SecondaryWrapper = styled(MessageWrapper)`
  margin-bottom: 0px;
`

export const InnerWrapper = styled.div`
  margin-top: 1.1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Header = styled.h2`
  font-size: 1.625rem;
  margin-bottom: 1.1rem;
  font-family: ${themeGet('headerFontFamilySemibold')};
  font-weight: 600;
`

export const CloseButton = styled.button.attrs({ type: 'button' })`
  margin-top: 1rem;
  width: 9.188rem;
  margin-left: auto;
  border-radius: 0.3125rem;
  background-color: #3c6e90;
  border: 0.125rem solid #3c6e90;
  color: white;
  height: 2.688rem;
  width: 6.875rem;
  &:not([disabled]):hover {
    background-color: ${themeGet('colors.secondStepBlue')};
    border-color: ${themeGet('colors.secondStepBlue')};
    color: white;
  }
`

export const Paragraph = styled.p`
  text-align: left;
  font-size: 0.813rem;
  line-height: 1.5rem;
  font-family: ${themeGet('fontFamily')};
  font-weight: 500;
  color: #555555;
`

export const SmallParagraph = styled(Paragraph)`
  font-size: 0.875rem;
`

export const BottomParagraph = styled(SmallParagraph)`
  margin-top: 0.375rem;
`

export const BoldParagraph = styled(Paragraph)`
  font-family: ${themeGet('fontFamilySemibold')};
  font-weight: 500;
  padding-left: 0.438rem;
  letter-spacing: 0;
  line-height: 1.5rem;
  color: #555555;
  font-size: 1rem;
`

export const EmailsTextArea = styled.div`
  padding-top: 0rem;
  height: 6.25rem;
  border: 0.0938rem solid #8393af;
  border-radius: 0.3125rem;
  background-color: #ffffff;
  text-align: initial;
  p {
    color: #555555;
    font-family: ${themeGet('fontFamily')};
    font-size: 1rem;
    letter-spacing: 0;
    line-height: 1.25rem;
    margin-left: 1rem;
  }
`

export const SecondEmailsTextArea = styled(EmailsTextArea)`
  height: 9.25rem;
`

export const CheckIcon = styled(SuccessIcon)`
  width: 1.375rem;
  height: 1.375rem;
`

export const ExclamationIcon = styled(WarningIcon)`
  width: 1.375rem;
  height: 1.375rem;
`

export const SquareIcon = styled.div`
  width: 0.688rem;
  height: 0.875rem;
  background-color: #a0a0a0;
  border: 0.0625rem solid white;
`

export const BottomSquareIcon = styled(SquareIcon)`
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
`

export const IconWrapper = styled.div`
  position: relative;
  margin-left: 0.5rem;
`

export const CopyWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-right: 0.75rem;
  cursor: pointer;
  p {
    margin-bottom: 0;
    font-size: 0.8125rem;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.5rem;
    font-family: ${themeGet('fontFamily')};
    color: #3c6e90;
  }
`
